import { BlockTypes } from 'enum/block-type.enum'
import { MeetingTypes } from 'enum/meetingTypes.enum'
import { MeetingIntegrationTypes } from 'enum/meetingIntegrationTypes.enum'
import { IEvaluationQuestion } from './evaluation.model'

export interface ISurveyBlockModel {
  block_survey: {
    send_email: true
  }
  block_instance: IBlockInstanceModel
}

export interface IRichTextBlockModel {
  block_rich_text: {
    content: ''
  }
  block_instance: IBlockInstanceModel
}

export interface ITaskBlockModel {
  block_task: {
    multiple_file_upload: true
    allow_public: false
    contain_files: false
  }
  block_instance: IBlockInstanceModel
}

export interface IMultimediaBlockModel {
  block_multimedia: {
    file: IFileBlockModel | null
    show_title: true
  }
  block_instance: IBlockInstanceModel
}
export interface IScormBlockModel {
  block_scorm: {
    file: null
    show_title: true
  }
  block_instance: IBlockInstanceModel
}

export interface IMeetingBlockModel {
  block_meeting: {
    config: any
    description: string
    duration: number
    startTime: string | null
    title: string
    typeMeet: MeetingTypes
  }
  block_instance: IBlockInstanceModel
}

export interface IMeetingBlockEditModel {
  block_meeting: {
    config: any
    description: string
    duration: number
    timezone: string
    startTime: string | null
    title: string
    typeMeet: MeetingTypes
    integrationType: MeetingIntegrationTypes
  }
  block_instance: Partial<IBlockInstanceModel>
}

export interface IEvaluationBlockModel {
  block_evaluation: {
    approval_points: number
    max_retries: number
    show_results: boolean
    random_questions: boolean
  }
  block_instance: IBlockInstanceModel
  upload_version?: boolean
}

export const blockSurveyInitialState: ISurveyBlockModel = {
  block_survey: {
    send_email: true,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockRichTextInitialState: IRichTextBlockModel = {
  block_rich_text: {
    content: '',
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockTaskInitialState: ITaskBlockModel = {
  block_task: {
    multiple_file_upload: true,
    allow_public: false,
    contain_files: false,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockMultimediaInitialState: IMultimediaBlockModel = {
  block_multimedia: {
    file: null,
    show_title: true,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockScormInitialState: IScormBlockModel = {
  block_scorm: {
    file: null,
    show_title: true,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockMeetingInitialState: IMeetingBlockModel = {
  block_meeting: {
    title: '',
    description: '',
    duration: 0,
    startTime: '',
    config: {},
    typeMeet: MeetingTypes.meeting,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: false,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export const blockEvaluationInitialState: IEvaluationBlockModel = {
  block_evaluation: {
    approval_points: 0,
    max_retries: 1,
    show_results: true,
    random_questions: true,
  },
  block_instance: {
    name: '',
    description: '',
    mandatory: true,
    order: 1,
    visible: true,
    lesson_id: 0,
  },
}

export interface IBlockInstancesModel {
  list: IBlockInstanceModel[]
  edit: IBlockInstanceModel
  loading: boolean
  internalLoading: boolean
  evaluation: IEvaluationQuestion
}

export interface IBlockInstanceModel {
  id?: number
  name: string
  description: string
  mandatory: boolean
  order: number
  visible?: boolean
  blockType?: BlockTypes
  blockId?: number
  instanceId?: number
  lessonId?: number
  lesson_id?: number
  content?: string
  blockInstanceableType?: string
  blockInstanceableId?: number
  blockInstanceable?: any
  questionsForms?: any[]
  showTitle?: boolean
  lockProgress?: boolean
  denyDownload?: boolean
  attachments?: any[]
  hasResponses?: boolean
  containFiles?: boolean
  file?: {
    id: number
    storage: string
    metadata: {
      size: number
      uppyId: string
      filename: string
      mimeType: string
    }
    url: string
  }
  evaluationConfig?: {
    approvalPoints: number
    maxRetries: number
    showResults: boolean
    randomQuestions: boolean
  }
  allowPublic?: boolean
  isValidated?: boolean
  processed?: boolean
  processing?: boolean
  loadPercentage?: number
  multiFile?: boolean
  openNewWindow?: boolean
  blockAdvance?: boolean
}

export const fileInitialState: IFileBlockModel = {
  id: 0,
  storage: 'cache',
  metadata: {
    size: 0,
    uppyId: '',
    filename: '',
    mimeType: '',
  },
}

export const initialState: IBlockInstanceModel = {
  id: 0,
  blockInstanceableType: '',
  description: '',
  mandatory: false,
  name: '',
  order: 0,
  visible: false,
  blockInstanceableId: 0,
  lessonId: 0,
  content: '',
  file: {
    id: 0,
    storage: '',
    metadata: {
      size: 0,
      uppyId: '',
      filename: '',
      mimeType: '',
    },
    url: '',
  },
}

export interface IBlockInstanceTypeModel {
  id: number
  type: string
}

export interface IFileBlockModel {
  id: number | string
  storage: string
  metadata: {
    size: number
    uppyId: string
    filename: string
    mimeType: string
  }
}

export interface IBlockMultimediaProgressModel {
  blockInstanceId: number
  id: number
  duration: string
  progress: string
}
